import { render, staticRenderFns } from "./AccordionTransfer.vue?vue&type=template&id=766c4466&"
import script from "./AccordionTransfer.vue?vue&type=script&lang=js&"
export * from "./AccordionTransfer.vue?vue&type=script&lang=js&"
import style0 from "./AccordionTransfer.vue?vue&type=style&index=0&id=766c4466&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports